// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ddporqgtozevotpuedsh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRkcG9ycWd0b3pldm90cHVlZHNoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3Nzk4NDEsImV4cCI6MjA2OTM1NTg0MX0.IpoMeiTY0nI3zjuPQeW9zvmbWnsAf6W2NuLELNLu6TA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});